"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Snackbar = {
  defaultProps: {
    alignTop: true,
    justify: "right"
  },
  styles: function styles(theme) {
    return {
      root: {
        backgroundColor: theme.colors.primary,
        marginTop: theme.spacing.base * 2,
        marginInlineEnd: theme.spacing.base * 2,
        padding: [theme.spacing.base * 2, theme.spacing.base * 3],
        borderRadius: 2,
        "& a": {
          textDecoration: "none",
          color: theme.colors.textOnDark
        }
      },
      message: {
        "p&": {
          color: theme.colors.textOnLight,
          padding: 0
        }
      }
    };
  }
};
var _default = exports.default = Snackbar;